'use client'

import { useEffect } from 'react'
import { useRouter } from '~/hooks/use-localized-navigation.hook'

import { PageLoader } from '~/components/page-loader'
import { SchedulingPage } from '~/domains/scheduling/scheduling-page'
import { useUserContext } from '~/providers/user-provider'

export const Page = () => {
	const router = useRouter()
	const { userQuery } = useUserContext()

	const dataFetched = userQuery.isSuccess
	const onboardingCompleted =
		dataFetched && !!userQuery.data?.onboarding?.scheduler

	useEffect(() => {
		if (!dataFetched) return
		if (onboardingCompleted) return

		void router.push('/scheduling/onboarding/welcome')
	}, [onboardingCompleted, dataFetched, router])

	if (!dataFetched || !onboardingCompleted) {
		return <PageLoader className='min-h-[50vh]' />
	}

	return <SchedulingPage />
}
